export default "__VITE_ASSET__Lnn2rXTd__"